import {RteLinkLazy} from 'app/modules/editorContent/rteLink/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineRteLink(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-rte-link')) {
        return;
    }

    customElements.define(
        'gem-rte-link',
        class extends WebComponentLoader {
            reactLazyComponent = RteLinkLazy;
            hasConfig = false;
            removePortalContent = false;
        },
    );
}
